const bindFormSubmitHandlers = () => {

  let loadingIndicator;

  // Create loading indicator
  const createLoadingIndicator = () => {
    const mainContent = document.querySelector('main');
    if (mainContent) {
      loadingIndicator = document.createElement('div');
      loadingIndicator.className = 'loading-indicator';
      mainContent.appendChild(loadingIndicator);
    }
  };

  // Remove loading indicator
  const removeLoadingIndicator = () => {
    if (loadingIndicator) {
      loadingIndicator.remove();
      loadingIndicator = null;
    }
  };

  // Handle multi-step form buttons
  const multiStepForms = document.querySelectorAll(".multi-step-form");
  const umbracoForms = document.querySelectorAll(".umbraco-forms-form");

  umbracoForms.forEach(umbracoForm => {
    reinitUmbracoForm(umbracoForm);
  });

  multiStepForms.forEach(formWrapper => {
    // Previous button
    formWrapper.addEventListener("click", e => {
      const target = e.target.closest("[name=__prev]");
      if (target) {
        e.preventDefault();
        const form = target.closest("form");
        window.clickedButton = "prev";
        form.requestSubmit();
        target.dispatchEvent(new Event("form-back", { bubbles: true }));
        target.setAttribute("disabled", "disabled");
      }
    });

    // Next button
    formWrapper.addEventListener("click", e => {
      const target = e.target.closest("[name=__next]");
      if (target) {
        e.preventDefault();
        const form = target.closest("form");
        window.clickedButton = "primary";
        form.requestSubmit();
        target.setAttribute("disabled", "disabled");
      }
    });
  });

  // Multi-step form submission
  document.querySelectorAll(".multi-step-form form").forEach(form => {
    form.addEventListener("submit", async e => {
      e.preventDefault();

      const currentNodePageUrl = document.querySelector("#pageInfoDiv")?.dataset.url;
      const umbracoFormsForm = form.closest(".umbraco-forms-form");
      const formId = umbracoFormsForm?.id;
      const formData = new FormData(form);
      const isPreviousClicked = window.clickedButton === "prev";
      if (isPreviousClicked) {
        formData.append("__prev", "Previous");
      }
      window.clickedButton = "";

      if (!form.dataset.submitted && form.checkValidity()) {
        createLoadingIndicator();
        form.dataset.submitted = "true";
        document.body.classList.add("loading");

        try{
          const response = await fetch(form.action, {
            method: "POST",
            body: formData
          });
          const html = await response.text();

          const parser = new DOMParser();
          const resultDoc = parser.parseFromString(html, "text/html");

          let thankYouMessage = resultDoc.querySelector(".umbraco-forms-submitmessage")
            || resultDoc.querySelector(".umbraco-forms-submitmessage-html");

          const errors = resultDoc.querySelectorAll(`#${formId} .field-validation-error`);
          const submitLastPage = form.querySelector(".multipage-lastpage");
          const resultNodePageUrl = resultDoc.querySelector("#pageInfoDiv")?.dataset.url;
          const resultStep = resultDoc.querySelector(`#${formId} input[name="FormStep"]`)?.value;
          const currentStep = form.querySelector('input[name="FormStep"]')?.value;
          const recordState = resultDoc.querySelector(`#${formId} input[name="RecordState"]`)?.value;
          const token = resultDoc.querySelector(`#${formId} input[name="__RequestVerificationToken"]`)?.value;
          const ufprt = resultDoc.querySelector(`#${formId} input[name="ufprt"]`)?.value;
          const id = resultDoc.querySelector(".umbraco-forms-page")?.id;

          if (resultStep) form.querySelector('input[name="FormStep"]').value = resultStep;
          if (recordState) form.querySelector('input[name="RecordState"]').value = recordState;
          if (token) form.querySelector('input[name="__RequestVerificationToken"]').value = token;
          if (ufprt) form.querySelector('input[name="ufprt"]').value = ufprt;
          if (id) form.querySelector(".umbraco-forms-page").id = id;

          if (isPreviousClicked) {
            form.dataset.submitted = "";
            const visible = getVisibleElement(".umbraco-forms-custom-class", form);
            if (visible) visible.remove();

            const replacement = resultDoc.querySelector(
              `#${formId}.multi-step-form form .umbraco-forms-custom-class`
            );

            if (replacement) {
              const target = form.querySelector(
                `.umbraco-forms-custom-class[data-step="${resultStep}"]`
              );
              if (target) {
                target.style.display = "block";
                target.innerHTML = replacement.innerHTML;
              }
            }

            reinitUmbracoForm(umbracoFormsForm);
            removeLoadingIndicator();
          } else if (errors.length > 0) {
            form.dataset.submitted = "";

            const replacement = resultDoc.querySelector(
              `#${formId}.multi-step-form form .umbraco-forms-custom-class`
            );

            if (replacement) {
              const visible = getVisibleElement(".umbraco-forms-custom-class", form);
              if (visible) {
                visible.innerHTML = replacement.innerHTML;
              }
            }

            reinitUmbracoForm(umbracoFormsForm);
            removeLoadingIndicator();
          } else if (resultNodePageUrl && resultNodePageUrl !== currentNodePageUrl) {
            form.dataset.submitted = "true";
            window.location.href = resultNodePageUrl;
          } else if (thankYouMessage) {
            form.dataset.submitted = "true";
            form.innerHTML = thankYouMessage.outerHTML;
            form.closest(".umbraco-forms-form").previousElementSibling?.classList.add("d-none");
            window.scrollTo({
              top: form.getBoundingClientRect().top + window.scrollY - document.querySelector("header").offsetHeight,
              behavior: "smooth"
            });
          } else if (submitLastPage) {
            form.dataset.submitted = "";
            window.location.href = resultNodePageUrl;
          } else {
            form.dataset.submitted = "";
            form.querySelectorAll(".umbraco-forms-custom-class").forEach(el => el.style.display = "none");
            const replacement = resultDoc.querySelector(`#${formId}.multi-step-form form .umbraco-forms-custom-class`);
            if (replacement) {
              replacement.classList.add("page-" + currentStep);
              form.querySelector(".umbraco-forms-page").appendChild(replacement);
            }
            reinitUmbracoForm(umbracoFormsForm);
            removeLoadingIndicator();
          }
        } catch (err) {
          removeLoadingIndicator();
          console.error("Single-step form error:", err);        
        }
      }
    });
  });

  document.querySelectorAll(".single-step-form form").forEach(form => {
    form.addEventListener("submit", async e => {
      e.preventDefault();
      const umbracoFormsForm = form.closest(".umbraco-forms-form");
      const formId = umbracoFormsForm?.id;
      if (!form.dataset.submitted && form.checkValidity()) {
        createLoadingIndicator();
        
        try {
          const response = await fetch(form.action, {
            method: "POST",
            body: new FormData(form)
          });
          const html = await response.text();

          const parser = new DOMParser();
          const resultDoc = parser.parseFromString(html, "text/html");

          let thankYouMessage = resultDoc.querySelector(".umbraco-forms-submitmessage")
            || resultDoc.querySelector(".umbraco-forms-submitmessage-html");
          const resultNodePageUrl = resultDoc.querySelector("#pageInfoDiv")?.dataset.url;
          const errors = resultDoc.querySelectorAll(`#${formId} .field-validation-error`);

          if (errors.length > 0) {
            form.dataset.submitted = "";

            const replacement = resultDoc.querySelector(
              `#${formId}.single-step-form form .umbraco-forms-custom-class`
            );

            if (replacement) {
              const visible = getVisibleElement(".umbraco-forms-custom-class", form);
              if (visible) {
                visible.innerHTML = replacement.innerHTML;
              }
            }

            reinitUmbracoForm(umbracoFormsForm);
            removeLoadingIndicator();
          } else if (thankYouMessage) {
            form.dataset.submitted = "true";
            form.innerHTML = thankYouMessage.outerHTML;
            form.closest(".umbraco-forms-form").previousElementSibling?.classList.add("d-none");
            window.scrollTo({
              top: form.getBoundingClientRect().top + window.scrollY - document.querySelector("header").offsetHeight,
              behavior: "smooth"
            });
            removeLoadingIndicator();
          } else if (resultNodePageUrl) {
            window.location.href = resultNodePageUrl;
          }
        } catch (err) {
          removeLoadingIndicator();
          console.error("Single-step form error:", err);
        }
      }
    });
  });
};

function getVisibleElement(selector, root = document) {
  const elements = root.querySelectorAll(selector);
  return Array.from(elements).find(el => el.offsetParent !== null) || null;
}

const reinitUmbracoForm = (umbracoFormsForm) => {
  const configEl = umbracoFormsForm.parentElement.querySelector('.umbraco-forms-form-config');
  if (!configEl) return;

  const config = {
    pageButtonConditions: JSON.parse(configEl.dataset.serializedPageButtonConditions),
    fieldSetConditions: JSON.parse(configEl.dataset.serializedFieldsetConditions),
    fieldConditions: JSON.parse(configEl.dataset.serializedFieldConditions),
    triggerConditionsCheckOn: configEl.dataset.triggerConditionsCheckOn,
    recordValues: JSON.parse(configEl.dataset.serializedFieldsNotDisplayed),
    formElementHtmlIdPrefix: configEl.dataset.formElementHtmlIdPrefix,
  };

  new window.UmbracoFormsWatcher(
    umbracoFormsForm,
    config.pageButtonConditions,
    config.fieldSetConditions,
    config.fieldConditions,
    config.triggerConditionsCheckOn,
    config.recordValues,
    config.formElementHtmlIdPrefix
  ).watch();
};

const removeDuplicateFormsFromDOM = () => {
  const found = {};
  document.querySelectorAll(".form-wrapper[data-form-id]").forEach(el => {
    const formId = el.getAttribute("data-form-id");
    if (found[formId]) {
      el.remove();
    } else {
      found[formId] = true;
    }
  });
};

const initializeHandleUmbracoFormsAjax = () => {
    removeDuplicateFormsFromDOM();
    bindFormSubmitHandlers();
};

export { initializeHandleUmbracoFormsAjax };
